<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import sl from '@/Prevodi/Sifranti_Letala_vnos-sl.json';
import en from '@/Prevodi/Sifranti_Letala_vnos-en.json';
import it from '@/Prevodi/Sifranti_Letala_vnos-it.json';
export default {
  components: {
    DropDown,
    Notification
  },
  props: {},
  emits: ['osvezi', 'odjava'],
  data() {
    return {
      registracija: '',
      tip: '',
      model: '',
      serijska: '',
      masa_plovila: '',
      klub: '',
      klubi: [],
      licence: [],
      sifrant_letal: [],
      stevilo_ur: 0,
      stevilo_letov: 0,
      vrsta_letala: [
        {id: 0, vrsta: 'Jadralno'},
        {id: 1, vrsta: 'Motorno'},
        {id: 2, vrsta: 'Vitla'},
        {id: 3, vrsta: 'Ultralight'},
      ],
      izbrana_vrsta: '',
      datum_nakupa: new Date().toISOString().split('T')[0],
      datum_registracije: new Date().toISOString().split('T')[0],
      opomba: '',
      vlecno: false,
      gost: false,
      dVrsta: false,
      dKlub: false,
      flight_time: false,
      razpolozljivost: false,
      camo_pregled: false,
      camo_flight: false,
      enotaMere: 'kg',
      dodajam: false,
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
  },
  mounted() {
    this.Read();
  },
  methods: {
    Read() {
      axios.get('./api/sifranti/klubi/izpis/').then((response) => {
        this.klubi = response.data.klubi;
        this.klubi.push({
          'id': 'lastno',
          'sifra': 'Privat-lastno',
          'naziv': 'Privat-lastno',
          'naslov': '/',
          'posta': '/',
          'kraj': '/',
          'tel': '/',
          'email': '/'
        });
      }).catch((error) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
      this.GetLicence();
      this.GetSifrantLetal();
    },
    GetLicence() {
      axios.post('./api/nastavitve/licence/izpis/', {}, {withCredentials: true}).then((response) => {
        this.licence = response.data.licence || [];
      }).catch((napaka) => {
        this.text = `Napaka pri branju licenc.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    GetSifrantLetal() {
      axios.get('./api/sifranti/letala/izpis/').then((response) => {
        this.sifrant_letal = response.data.letala || [];
      }).catch((napaka) => {
        this.text = `Napaka pri branju šifranta letal.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    ValidateLicenceLimit() {
      if (this.klub === '') return true;

      // Ajdovščina = id 5 - VSA letala se štejejo kot na Ajdovščini
      const LETALISCA_AJDOVSCINA_ID = 5;

      // Najdi licenco za Ajdovščino
      const licence = this.licence.find(l => l.id_letalisca === LETALISCA_AJDOVSCINA_ID);
      if (!licence) {
        this.text = `Licenca za letališče Ajdovščina ne obstaja. Prosimo kontaktirajte administratorja.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
        return false;
      }

      // 1. Preveri omejitev LETALA
      // VSA letala v sifrant_letal so na Ajdovščini
      const obstojecaLetala = this.sifrant_letal.length;

      if (obstojecaLetala >= licence.st_letal) {
        this.text = `Presegli ste dovoljeno število letal (${licence.st_letal}). Zakupite dodatno licenco za povečanje limita.`;
        this.types = 'Napaka';
        this.ShowNoti = true;
        return false;
      }

      return true;
    },
    Add() {
      if (this.klub !== '' && !this.ValidateLicenceLimit()) {
        return;
      }

      if (this.registracija !== '' && this.vlecno !== '' && this.tip !== '' && this.klub !== '' && this.stevilo_ur !== '' && this.datum_nakupa !== '' && this.datum_registracije !== '' && this.izbrana_vrsta !== '') {
        this.dodajam = true;
        let app = this;
        const klubZaVnos = app.klub;
        let dodaj = new URLSearchParams();
        dodaj.append('registracija', app.registracija);
        dodaj.append('vlecno', app.vlecno);
        dodaj.append('tip', app.tip);
        dodaj.append('model', app.model);
        dodaj.append('serijska', app.serijska);
        dodaj.append('masa_plovila', app.masa_plovila);
        dodaj.append('masa_enota', app.enotaMere);
        dodaj.append('klub', app.klub);
        if (this.gost) {
          this.stevilo_ur = '';
          this.datum_nakupa = '';
          this.datum_registracije = '';
        }
        dodaj.append('st_ur', app.stevilo_ur);
        dodaj.append('st_letov', app.stevilo_letov);
        dodaj.append('vrsta_letala', app.izbrana_vrsta);
        dodaj.append('datum_nakupa', app.datum_nakupa);
        dodaj.append('datum_registracije', app.datum_registracije);
        dodaj.append('opomba', app.opomba);
        dodaj.append('flight_time', app.flight_time);
        dodaj.append('razpolozljivost', app.razpolozljivost);
        dodaj.append('camo_pregled', app.camo_pregled);
        if(this.camo_pregled) {
          dodaj.append('camo_flight', this.camo_flight);
        }
        axios
            .post("./api/sifranti/letala/vnos/", dodaj, {withCredentials: true})
            .then((response) => {
              // alert("Zapis uspešno dodan!");
              app.text = "Zapis uspešno dodan!";
              app.types = "Uspešno";
              app.ShowNoti = true;
              app.sifrant_letal.push({klub: klubZaVnos});
              app.registracija = '';
              app.vlecno = false;
              app.tip = '';
              app.klub = '';
              app.stevilo_ur = 0;
              app.stevilo_letov = 0;
              app.izbrana_vrsta = '';
              app.datum_nakupa = new Date().toISOString().split('T')[0];
              app.datum_registracije = new Date().toISOString().split('T')[0];
              app.opomba = '';
              app.gost = false;
              app.razpolozljivost = false;
              app.camo_pregled = false;
              app.camo_flight = false;
              app.masa_plovila = '';
              app.enotaMere = 'kg';
              app.GetSifrantLetal();
              app.GetLicence();
              app.$emit('osvezi');
              let requiredPolja = ['registracija', 'vlecno', 'tip', 'klub', 'stevilo_ur', 'datum_nakupa', 'datum_registracije', 'izbrana_vrsta'];
              app.ResetRequired(requiredPolja);
              this.dodajam = false;
            })
            .catch((napaka) => {
              this.dodajam = false;
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                this.text = 'Napaka pri vnosu podatkov. ' + napaka.response.data.napaka;
              } else {
                this.text = 'Napaka pri vnosu podatkov.';
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
            })
      } else {
        // alert("Manjkajo podatki, preveri če si izpolnil vse potrebne podatke!");
        var requiredPolja = ['registracija', 'vlecno', 'tip', 'klub', 'stevilo_ur', 'datum_nakupa', 'datum_registracije', 'izbrana_vrsta'];
        this.CheckInputs(requiredPolja);
        this.text = "Manjkajo podatki, preveri če si izpolnil vse potrebne podatke!";
        this.types = "Napaka";
        this.ShowNoti = true;
      }

    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]);
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    selectVrsta(id) {
      let vrsta = this.vrsta_letala.find(v => v.id === id);
      if (vrsta) {
        this.dVrsta = false;
        this.izbrana_vrsta = vrsta.vrsta;
      }
    },
    OpenVrsta() {
      this.dVrsta = !this.dVrsta;
    },
    selectKlub(id) {
      let klub = this.klubi.find(vl => vl.id === id);
      if (klub) {
        this.dKlub = false;
        this.klub = klub.naziv;
      }
    },
    OpenKlub() {
      this.dKlub = !this.dKlub;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="container p-2">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="vlecno">{{$t('labels.tuje')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="checkbox" id="gostovanje" value="true" v-model="gost" />
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: registracija.length > 0 }" class="label" for="registracija">{{$t('labels.reg')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="registracija" v-model="registracija" required />
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: tip.length > 0 }" class="label" for="tip">Tip</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="tip" v-model="tip" required />
      </div>
    </div>
    <!-- MODEL -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: model.length > 0 }" class="label" for="model">Model</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="model" v-model="model" required />
      </div>
    </div>
    <!-- SERIJSKA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: serijska.length > 0 }" class="label" for="serijska">Serijska št.</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="serijska" v-model="serijska" required />
      </div>
    </div>
    <!-- TEŽA LETALA -->
    <div class="col-12">
      <div class="d-flex justify-content-between">
        <div class="container">
        <label :class="{ hidden: masa_plovila > 0 }" class="label" for="masa_plovila">Teža plovila.</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" step="0.1" id="masa_plovila" v-model="masa_plovila" required />
        </div>
        <div class="btn-group ms-2 p-2 mt-3" role="group" aria-label="Izbira enote mere">
          <input
              id="enotaKg"
              v-model="enotaMere"
              class="btn-check"
              type="radio"
              value="kg"
          >
          <label
              class="btn btn-outline-light"
              for="enotaKg"
          >
            EU
          </label>

          <input
              id="enotaLbs"
              v-model="enotaMere"
              class="btn-check"
              type="radio"
              value="lbs"
          >
          <label
              class="btn btn-outline-light"
              for="enotaLbs"
          >
            USA
          </label>

        </div>
      </div>
    </div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: klub.length > 0 }" class="label" for="klub">Klub</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="klub" v-model="klub" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="namen">{{$t('labels.klub')}} <button v-if="klub !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="klub = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenKlub()">
          <i v-show="!dKlub" class="fas fa-chevron-right"></i>
          <i v-show="dKlub" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="klub" @click.prevent="OpenKlub">{{klub}}</button>
        <transition name="fade">
          <drop-down @klub="selectKlub" :data="klubi" type="klubi" class="drop-down-btn" v-if="dKlub" />
        </transition>
      </div>
    </div>
    <div class="col-12" v-if="!gost">
      <div class="container">
        <label :class="{ hidden: stevilo_ur.length > 0 }" class="label-time p-2" for="stevilo_ur">{{$t('labels.stUr')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="stevilo_ur" v-model="stevilo_ur" required />
      </div>
    </div>
    <div class="col-12" v-if="!gost">
      <div class="container">
        <label :class="{ hidden: stevilo_letov.length > 0 }" class="label-time p-2" for="stevilo_letov">{{$t('labels.stLetov')}}</label>
        <input class="input border-0 rounded-4 p-2 fs-5" type="number" id="stevilo_letov" v-model="stevilo_letov" required />
      </div>
    </div>
    <div class="col-12" v-if="!gost">
      <div class="container">
        <div class="label-date p-2 col-6" for="datum_nakupa">{{$t('labels.datumN')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum_nakupa" v-model="datum_nakupa" required />
      </div>
    </div>
    <div class="col-12" v-if="!gost">
      <div class="container">
        <div class="label-date p-2 col-7" for="datum_registracije">{{$t('labels.datumR')}}</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum_registracije" v-model="datum_registracije" required />
      </div>
    </div>
    <div class="col-12">
      <!-- <div class="container">
          <label class="label-date p-2 col-6" for="vrsta_letala">Vrsta letala :</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="vrsta_letala" v-model="vrsta_letala" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="vrsta">{{$t('labels.vrsta')}} <button v-if="izbrana_vrsta !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="izbrana_vrsta = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
        <div class="drop-down-icon text-black" @click.prevent="OpenVrsta()">
          <i v-show="!dVrsta" class="fas fa-chevron-right"></i>
          <i v-show="dVrsta" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="izbrana_vrsta" @click.prevent="OpenVrsta">{{izbrana_vrsta}}</button>
        <transition name="fade">
          <drop-down @vrsta="selectVrsta" :data="vrsta_letala" type="vrsta" class="drop-down-btn" v-if="dVrsta" />
        </transition>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="vlecno">{{$t('labels.vlecno')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input class="input-radio" type="radio" id="vlecnoDa" value="true" v-model="vlecno" />
          <label class="label-radio" for="vlecnoDa">{{$t('labels.vlecnoD')}}</label>
          <input class="input-radio" type="radio" id="vlecnoNe" value="false" v-model="vlecno" />
          <label class="label-radio" for="vlecnoNe">{{$t('labels.vlecnoN')}}</label>
        </div>
      </div>
    </div>
    <!-- OBRAČUN ŠTEVEC SWITCH -->
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="vlecno">{{$t('labels.obracunStevec')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <label class='switch col-6'>
            <input type='checkbox'  v-model="flight_time" :checked="flight_time">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- PRIKAZ V RAZPOLOŽLJIVOSTI -->
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="razpolozljivost">{{$t('labels.razpolozljivost')}}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <label class='switch col-6'>
            <input type='checkbox'  v-model="razpolozljivost" :checked="razpolozljivost">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- LETALO ZA CAMO -->
    <div class="col-12">
      <div class="container">
        <label class="label-choose" for="camo_pregled">{{ $t('labels.camo_pregled') }}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <label class='switch col-6'>
            <input type='checkbox'  v-model="camo_pregled" :checked="camo_pregled">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- CAMO FLIGHT ČAS -->
    <div class="col-12" v-if="camo_pregled">
      <div class="container">
        <label class="label-choose" for="camo_pregled">{{ $t('labels.camo_flight') }}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <label class='switch col-6'>
            <input type='checkbox'  v-model="camo_flight" :checked="camo_flight">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: opomba.length > 0 }" class="label" for="opomba">{{$t('labels.opomba')}}</label>
        <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opomba" v-model="opomba" rows="6" autocomplete="off">
                    </textarea>
      </div>
    </div>
    <div class="container p-2">
      <button @click.prevent="Add()" :disabled="dodajam" class="btn btn-primary rounded-pill btn-add col-12">
        {{$t('buttons.vnos')}} <i class="fas fa-spinner fa-spin" v-if="dodajam"></i>
      </button>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>